import { render, staticRenderFns } from "./BudgetItemEdit.vue?vue&type=template&id=c4714f22&scoped=true&"
import script from "./BudgetItemEdit.vue?vue&type=script&lang=js&"
export * from "./BudgetItemEdit.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "c4714f22",
  null
  
)

export default component.exports